module.exports = __webpack_public_path__ + "img/rotaract_logo.501325c8.png";